import React from 'react';
import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import { COLORS } from 'apps/web_forms/utils/constants';

const LoadingStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #f7f7f7;
  z-index: 4;
`;

const Loading = () => {
  return (
    <LoadingStyled data-testid="loading">
      <Loader type="Oval" color={COLORS.primary} height="16em" width={100} />
    </LoadingStyled>
  );
};

export default Loading;
